import AWS from 'aws-sdk';
import axios from "axios";
import {Notifier} from "./Notifier";
import i18n from "../i18n";

AWS.config.region = 'eu-west-1';

export class FileDownloader {
    static downloadFile(signedDownloadUrlGeneratorUrl, name) {
        return new Promise(async (resolve) => {
            const loadingController = document.querySelector('ion-loading-controller');
            await loadingController.componentOnReady();

            const loader = await loadingController.create({
                duration: 1000000,
            });

            await loader.present();

            axios
                .get(signedDownloadUrlGeneratorUrl)
                .then(async ({data}) => {

                    // const a = document.createElement('a');
                    // a.target = '_blank';
                    // a.href = data;
                    // a.innerText = 'Download ' + name;
                    // a.setAttribute('download', name);
                    // document.body.appendChild(a);
                    // a.click();

                    await loader.dismiss();

                    const downloadButton = `<ion-button id="temp-file-download-button" href="${data}" target="_blank" download="${name}">Start download</ion-button>`;

                    const alert = await Notifier.showAlert({
                        header: i18n.t('ncrypt.alert.file_download_ready_title'),
                        message: i18n.t('ncrypt.alert.file_download_ready_message').replace('{url}', downloadButton),
                        cssClass: 'file-download-alert',
                    });

                    document.getElementById('temp-file-download-button').addEventListener('click', () => alert.dismiss());

                    resolve();
                });
        });
    }
}
